export default {
  title: "KW"
};
